export default __webpack_public_path__ + "static/media/cart.924fe67e.svg";